// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LCRc","colMin":"styles_colMin__3mRAg"};